export function setVisitedPageState(page: string) {
  localStorage.setItem(`visited-${page}`, 'true');
};

export function getVisitedPageState(page: string) {
  return localStorage.getItem(`visited-${page}`);
};
